"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.donationTypeName = exports.userRoleName = exports.isModerator = exports.isManager = exports.isChannelManager = exports.isChatManager = exports.isStreamer = void 0;
function isStreamer(profile) {
    return profile.userRoleCode == "streamer";
}
exports.isStreamer = isStreamer;
function isChatManager(profile) {
    return profile.userRoleCode == "streaming_chat_manager";
}
exports.isChatManager = isChatManager;
function isChannelManager(profile) {
    return profile.userRoleCode == "streaming_channel_manager";
}
exports.isChannelManager = isChannelManager;
function isManager(profile) {
    return profile.userRoleCode == "manager";
}
exports.isManager = isManager;
function isModerator(profile) {
    return isStreamer(profile) || isChatManager(profile) || isChannelManager(profile) || isManager(profile);
}
exports.isModerator = isModerator;
function userRoleName(userRoleCode) {
    switch (userRoleCode) {
        case "streamer":
            return "스트리머";
        case "streaming_chat_manager":
            return "채팅 운영자";
        case "streaming_channel_manager":
            return "채널 관리자";
        case "manager":
            return "운영자";
        case "common_user":
            return "일반 사용자";
        default:
            return "알 수 없음";
    }
}
exports.userRoleName = userRoleName;
function donationTypeName(donationType) {
    switch (donationType) {
        case "CHAT":
            return "채팅 후원";
        case "VIDEO":
            return "영상 후원";
        case "MISSION":
            return "미션 후원";
        default:
            return "알 수 없음";
    }
}
exports.donationTypeName = donationTypeName;
